import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { Trilha } from '../../components/Trilha';

/* Medidas e cores do protótipo da galeria (copasul-galeria.html), valendo só
   dentro desta página. */
export const Pagina = styled.div`
  --verde: #008d3c;
  --verde-escuro: #0b4e30;
  --tinta: #183b2c;
  --apagado: #68776e;
  --linha: #dce5dd;
  --papel: #fff;
  --gutter: clamp(1.375rem, 4vw, 2.5rem);

  background: var(--papel);
  color: var(--tinta);
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif;
  text-align: left;

  a {
    color: inherit;
    text-decoration: none;
  }

  button {
    font: inherit;
    color: inherit;
    cursor: pointer;
  }

  a:focus-visible,
  button:focus-visible {
    outline: 3px solid #d1a82e;
    outline-offset: 4px;
  }

  /* Campo de texto e seletor ganham foco também no clique, e o contorno
     aparecia toda vez. Na busca o cursor piscando já mostra onde está o foco;
     o seletor de anos troca a cor da borda (ver OutrosAnos). */
  input:focus,
  select:focus {
    outline: none;
  }

  img {
    display: block;
  }

  /* Foto em pé num quadro deitado: o recorte fica perto do topo, para cortar os
     pés e não o rosto. Marcada pelo FotoEnquadrada ao carregar. */
  img[data-retrato] {
    object-position: 50% 12%;
  }

  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      transition: none !important;
      animation: none !important;
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1320px;
  margin-inline: auto;
  padding-inline: var(--gutter);
  box-sizing: border-box;
`;

export const Chapeu = styled.p`
  margin: 0 0 1rem;
  font-size: 0.625rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--verde);
`;

export const Titulo = styled.h1`
  margin: 0;
  font-size: clamp(2.6rem, 4.8vw, 4.25rem);

  @media (max-width: 420px) {
    font-size: 2.25rem;
  }
  font-weight: 500;
  line-height: 1.03;
  letter-spacing: -0.045em;
  color: var(--tinta);
  text-wrap: balance;

  em {
    font-family: Georgia, 'Times New Roman', serif;
    font-weight: 400;
    color: var(--verde);
  }
`;

/* --------------------------------------------------------------- abertura */

export const TrilhaDaPagina = styled(Trilha)`
  margin-bottom: 1.5rem;
`;

export const Abertura = styled.section`
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 1.875rem;
  padding: clamp(1.5rem, 3vw, 2.25rem) 0 2.2rem;

  > p {
    margin: 0 0 0.2rem;
    max-width: 19.5rem;
    font-size: 0.875rem;
    line-height: 1.7;
    color: var(--apagado);
  }

  @media (max-width: 720px) {
    display: block;

    > p {
      max-width: none;
      margin-top: 1.25rem;
      font-size: 0.8125rem;
    }
  }
`;

/* ------------------------------------------------------------- destaques */

export const Destaques = styled.section`
  display: grid;
  grid-template-columns: ${({ $quantos }) => ($quantos > 1 ? '1.65fr 1fr' : '1fr')};
  grid-template-rows: repeat(2, clamp(13.5rem, 17vw, 15.3rem));
  gap: 0.875rem;

  @media (max-width: 1050px) {
    grid-template-columns: ${({ $quantos }) => ($quantos > 1 ? '1.3fr 1fr' : '1fr')};
  }

  @media (max-width: 720px) {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 20rem 12rem;
    gap: 0.625rem;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    grid-template-rows: 18rem;
    grid-auto-rows: 13rem;
  }
`;

export const Destaque = styled(Link)`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  border-radius: 8px;
  background: var(--verde-escuro);
  color: #fff;
  grid-row: ${({ $principal }) => ($principal ? 'span 2' : 'auto')};

  > img {
    position: absolute;
    inset: 0;
    z-index: -2;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.6s;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.04) 20%, rgba(5, 32, 17, 0.84) 100%);
  }

  &:hover > img {
    transform: scale(1.035);
  }

  > div {
    position: absolute;
    left: 1.5rem;
    right: 1.5rem;
    bottom: 1.4rem;
  }

  /* Cor explícita: o "a { color: inherit }" da página pesa mais que o branco do cartão. */
  time {
    font-size: 0.625rem;
    color: rgba(255, 255, 255, 0.85);
  }

  h2 {
    margin: 0.55rem 3rem 0 0;
    font-size: ${({ $principal }) => ($principal ? 'clamp(2rem, 2.8vw, 2.45rem)' : '1.45rem')};
    font-weight: 500;
    line-height: 1.08;
    letter-spacing: -0.02em;
    color: #fff;
    max-width: ${({ $principal }) => ($principal ? '24rem' : 'none')};
  }

  @media (max-width: 720px) {
    grid-row: auto;
    grid-column: ${({ $principal }) => ($principal ? 'span 2' : 'auto')};

    > div {
      left: 1rem;
      right: 1rem;
      bottom: 1.1rem;
    }

    h2 {
      margin-right: 0;
      font-size: ${({ $principal }) => ($principal ? '2rem' : '1.05rem')};
    }
  }

  @media (max-width: 560px) {
    grid-column: auto;

    h2 {
      font-size: ${({ $principal }) => ($principal ? '1.75rem' : '1.3rem')};
    }
  }
`;

export const Etiqueta = styled.span`
  position: absolute;
  top: 1.4rem;
  left: 1.5rem;
  padding: 0.45rem 0.55rem;
  border: 1px solid rgba(255, 255, 255, 0.46);
  border-radius: 3px;
  background: rgba(24, 59, 44, 0.19);
  color: #fff;
  font-size: 0.5625rem;
  letter-spacing: 0.08em;
  text-transform: uppercase;

  @media (max-width: 720px) {
    top: 1rem;
    left: 1rem;
  }
`;

export const Seta = styled.span`
  position: absolute;
  right: 0;
  bottom: 0;
  display: grid;
  place-items: center;
  width: 2.3rem;
  height: 2.3rem;
  border: 1px solid rgba(255, 255, 255, 0.44);
  border-radius: 50%;
  color: #fff;
  transition: background 0.2s, color 0.2s, border-color 0.2s;

  ${Destaque}:hover & {
    border-color: #fff;
    background: #fff;
    color: var(--verde-escuro);
  }

  @media (max-width: 720px) {
    display: none;
  }
`;

/* ----------------------------------------------------------------- lista */

/* A lista continua o fundo branco do topo e dos destaques: os dois são uma seção só. */
export const Lista = styled.section`
  margin-top: 2.5rem;

  @media (max-width: 720px) {
    margin-top: 1.75rem;
  }
`;

export const BarraDaSecao = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 1.25rem;
  margin: 0 0 1.45rem;
  padding-top: 2rem;

  h2 {
    margin: 0;
    font-size: clamp(1.6rem, 2.4vw, 1.8rem);
    font-weight: 500;
    letter-spacing: -0.025em;
    color: var(--tinta);
  }

  small {
    font-size: 0.6875rem;
    color: var(--apagado);
  }

  @media (max-width: 720px) {
    padding-top: 1.5rem;
  }

  @media (max-width: 560px) {
    small {
      display: none;
    }
  }
`;

export const Ferramentas = styled.div`
  display: flex;
  align-items: center;
  gap: 1.125rem;
  margin-bottom: 1.75rem;
  padding: 1rem 0;
  border-block: 1px solid var(--linha);

  @media (max-width: 720px) {
    flex-wrap: wrap;
    gap: 0.625rem;
  }
`;

export const Busca = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  gap: 0.75rem;
  max-width: 27rem;

  input {
    width: 100%;
    padding: 0.55rem 0;
    border: 0;
    background: transparent;
    font: inherit;
    font-size: 0.9375rem;
    color: var(--tinta);
  }

  input::-webkit-search-cancel-button {
    display: none;
  }

  svg {
    flex-shrink: 0;
    color: var(--apagado);
  }

  button {
    display: grid;
    place-items: center;
    padding: 0.25rem;
    border: 0;
    background: transparent;
  }

  @media (max-width: 720px) {
    flex-basis: 100%;
    max-width: none;
  }
`;

export const Anos = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.375rem;
  margin-left: auto;

  button {
    padding: 0.55rem 0.95rem;
    border: 1px solid transparent;
    border-radius: 4px;
    background: transparent;
    font-size: 0.75rem;
    transition: background 0.15s, border-color 0.15s;
  }

  /* O cinza no hover mostra a área clicável de cada ano. */
  button:hover {
    background: #eef2ef;
  }

  /* Ano escolhido no verde-escuro da página (o mesmo dos destaques e dos botões). */
  button[aria-pressed='true'],
  button[aria-pressed='true']:hover {
    background: var(--verde-escuro);
    color: #fff;
  }

  @media (max-width: 720px) {
    margin-left: 0;
  }
`;

/* Seletor dos anos anteriores: com cara de botão, aceso quando um ano dele está escolhido. */
export const OutrosAnos = styled.label`
  position: relative;
  display: inline-flex;
  align-items: center;

  select {
    appearance: none;
    padding: 0.55rem 1.9rem 0.55rem 0.95rem;
    border: 1px solid ${({ $ativo }) => ($ativo ? 'var(--verde-escuro)' : 'var(--linha)')};
    border-radius: 4px;
    background: ${({ $ativo }) => ($ativo ? 'var(--verde-escuro)' : 'transparent')};
    font: inherit;
    font-size: 0.75rem;
    color: ${({ $ativo }) => ($ativo ? '#fff' : 'inherit')};
    cursor: pointer;
    transition: background 0.15s, border-color 0.15s;
  }

  select:hover {
    border-color: ${({ $ativo }) => ($ativo ? 'var(--verde-escuro)' : '#c3ccc7')};
    background: ${({ $ativo }) => ($ativo ? 'var(--verde-escuro)' : '#eef2ef')};
  }

  select:focus-visible {
    border-color: var(--verde);
  }

  option {
    background: #fff;
    color: var(--tinta);
  }

  svg {
    position: absolute;
    right: 0.65rem;
    pointer-events: none;
    color: ${({ $ativo }) => ($ativo ? '#fff' : 'var(--apagado)')};
  }
`;

export const Contagem = styled.span`
  margin-left: 1rem;
  font-size: 0.6875rem;
  color: var(--apagado);

  @media (max-width: 720px) {
    margin-left: auto;
  }

  @media (max-width: 560px) {
    flex-basis: 100%;
    margin-left: 0;
  }
`;

export const Grade = styled.section`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1.75rem;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.75rem 1.1rem;
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
    gap: 2.25rem;
  }
`;

export const CartaoFoto = styled.div`
  position: relative;
  overflow: hidden;
  aspect-ratio: 1.52;
  border-radius: 6px;
  background: #dbe3d8;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s;
  }

  @media (max-width: 720px) {
    aspect-ratio: 1.1;
  }
`;

export const Revelar = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(11, 78, 48, 0.42);
  opacity: 0;
  transition: opacity 0.2s;

  span {
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    padding: 0.75rem 1.1rem;
    border-radius: 30px;
    background: #fff;
    font-size: 0.75rem;
    color: var(--verde-escuro);
  }
`;

export const Cartao = styled.a`
  display: block;

  &:hover ${CartaoFoto} img {
    transform: scale(1.04);
  }

  &:hover ${Revelar}, &:focus-visible ${Revelar} {
    opacity: 1;
  }

  h3 {
    margin: 0.625rem 0;
    font-size: 1.3rem;
    font-weight: 500;
    line-height: 1.2;
    letter-spacing: -0.02em;
    color: var(--tinta);
  }

  p {
    margin: 0;
    font-size: 0.8125rem;
    line-height: 1.65;
    color: var(--apagado);
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  @media (max-width: 720px) {
    h3 {
      font-size: 1.1rem;
    }

    p {
      display: none;
    }
  }

  @media (max-width: 560px) {
    h3 {
      font-size: 1.25rem;
    }

    p {
      display: -webkit-box;
      -webkit-line-clamp: 2;
    }
  }
`;

export const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.375rem;
  margin-top: 1.05rem;
  font-size: 0.625rem;
  color: var(--apagado);

  time,
  span {
    white-space: nowrap;
  }

  @media (max-width: 720px) {
    font-size: 0.5625rem;
    line-height: 1.5;
  }

  @media (max-width: 560px) {
    font-size: 0.6875rem;
  }
`;

/* Busca sem resultado: a seção mantém altura, senão a faixa final sobe colada. */
export const Vazio = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.9rem;
  min-height: 18rem;
  text-align: center;
  color: var(--apagado);

  p {
    margin: 0;
    font-size: 0.9375rem;
  }

  button {
    padding: 0;
    border: 0;
    background: transparent;
    font-size: 0.8125rem;
    color: var(--verde);
    text-decoration: underline;
    text-underline-offset: 3px;
  }
`;

export const CarregarMais = styled.button`
  display: block;
  margin: 2.6rem auto 0;
  padding: 0.85rem 1.6rem;
  border: 1px solid var(--verde-escuro);
  border-radius: 4px;
  background: transparent;
  font-size: 0.8125rem;
  color: var(--verde-escuro);
  transition: background 0.2s, color 0.2s;

  &:hover {
    background: var(--verde-escuro);
    color: #fff;
  }
`;

export const Fim = styled.p`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  /* No álbum a linha fica no meio entre a grade e "Outros álbuns": acima, o
     mesmo respiro que a seção de baixo tem no topo. */
  margin: ${({ $noMeio }) => ($noMeio ? 'clamp(3.5rem, 6vw, 5rem)' : '2.6rem')} 0 0;
  font-size: 0.625rem;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--apagado);

  &::before,
  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--linha);
  }
`;

/* ----------------------------------------------------------- faixa final */

/* O fechamento da página, antes do rodapé: a frase grande, com um traço verde
   abrindo e a assinatura alinhada pela base, do outro lado. Mesmo respiro em
   cima e embaixo, para a frase ficar no meio entre o fim da lista e o rodapé. */
export const FaixaFinal = styled.section`
  padding: clamp(4rem, 8vw, 6.5rem) 0;
  background: var(--papel);

  ${Container} {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: end;
    gap: 2.5rem;
  }

  p {
    position: relative;
    margin: 0;
    padding-top: 1.75rem;
    max-width: 42rem;
    font-family: Georgia, 'Times New Roman', serif;
    font-size: clamp(1.9rem, 3.4vw, 2.75rem);
    line-height: 1.16;
    letter-spacing: -0.01em;
    color: var(--tinta);
    text-wrap: balance;
  }

  p::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 3rem;
    height: 3px;
    border-radius: 2px;
    /* Âmbar, como os traços do resto do site. */
    background: var(--sixth-color);
  }

  span {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding-bottom: 0.45rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    white-space: nowrap;
    color: var(--verde-escuro);
  }

  span::before {
    content: '';
    width: 2.5rem;
    height: 1px;
    background: currentColor;
    opacity: 0.5;
  }

  @media (max-width: 720px) {
    ${Container} {
      grid-template-columns: 1fr;
      justify-items: center;
      gap: 1.75rem;
      text-align: center;
    }

    p {
      margin-inline: auto;
    }

    p::before {
      left: 50%;
      transform: translateX(-50%);
    }

    /* fio dos dois lados, como uma assinatura centralizada */
    span {
      justify-content: center;
      white-space: normal;
    }

    span::after {
      content: '';
      width: 2.5rem;
      height: 2px;
      border-radius: 1px;
      background: var(--sixth-color);
    }
  }
`;

/* -------------------------------------------------------- página do álbum */

export const CabecalhoAlbum = styled.header`
  padding: clamp(1.5rem, 3vw, 2.25rem) 0 1.25rem;

  ${Chapeu} {
    display: block;
    margin-top: 1.9rem;
  }

  ${Titulo} {
    margin: 1rem 0 1.4rem;
    font-size: clamp(2.2rem, 5vw, 3.9rem);
    letter-spacing: -0.03em;
    line-height: 1.06;

    /* O traço âmbar sob o título, como nos títulos de seção da Home. */
    &::after {
      content: '';
      display: block;
      width: 3rem;
      height: 0.1875rem;
      margin-top: 0.875rem;
      border-radius: 0.25rem;
      background: var(--sixth-color);
    }
  }

  > p {
    margin: 0 0 1rem;
    text-align: justify;
    font-size: clamp(0.875rem, 1.2vw, 1rem);
    line-height: 1.75;
    color: var(--apagado);
    white-space: pre-line;

    /* em coluna estreita o justificado abre buracos entre as palavras */
    @media (max-width: 600px) {
      text-align: left;
    }
  }
`;

export const Compartilhar = styled.div`
  position: relative;

  > button {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0;
    border: 0;
    background: transparent;
    font-size: 0.75rem;
    color: var(--verde);
  }

  /* No celular: área de toque maior que o texto, sem mudar o espaço que ocupa. */
  @media (max-width: 720px) {
    > button {
      padding: 0.6rem 0;
      margin: -0.6rem 0;
    }
  }
`;

export const TopoDaGrade = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.25rem;
  margin-top: 1.9rem;
  padding: 1.25rem 0;
  border-top: 1px solid var(--linha);

  strong {
    font-size: 0.8125rem;
    font-weight: 500;
  }

  span {
    font-size: 0.6875rem;
    color: var(--apagado);
  }

  @media (max-width: 600px) {
    flex-direction: column;
    align-items: start;
    gap: 0.5rem;
  }
`;

export const Numero = styled.span`
  position: absolute;
  left: 0.75rem;
  bottom: 0.75rem;
  padding: 0.375rem 0.5rem;
  border-radius: 3px;
  background: rgba(9, 46, 32, 0.72);
  font-size: 0.625rem;
  color: #fff;
`;

/* A cada 11 fotos, uma grande (2×2). A faixa larga (2×1) do protótipo saiu: ela
   cortava demais as fotos deitadas. */
export const Fotos = styled.section`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-auto-rows: 215px;
  gap: 0.75rem;

  > button {
    position: relative;
    overflow: hidden;
    padding: 0;
    border: 0;
    border-radius: 5px;
    background: #dbe3d8;
  }

  > button:nth-child(11n + 1) {
    grid-column: span 2;
    grid-row: span 2;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.3s;
  }

  > button:hover img {
    transform: scale(1.035);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    grid-auto-rows: 170px;
  }

  @media (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-auto-rows: 145px;
    gap: 0.5rem;

    > button:nth-child(11n + 1) {
      grid-row: span 1;
    }
  }
`;

/* -------------------------------------------------------- outros álbuns */

/* Outros álbuns: cabeçalho e setas do rail compartilhado (components/Vitrine),
   em fundo branco. A linha de fim da grade fica logo acima. */
export const Outros = styled.section`
  padding: clamp(3.5rem, 6vw, 5rem) 0 clamp(2.5rem, 4vw, 3.5rem);
  background: var(--papel);
`;

/* O cartão de foto: a capa ocupa o cartão inteiro, com degradê verde-escuro
   embaixo para a data e o título em branco. */
export const CartaoOutro = styled(Link)`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  flex: 0 0 calc((100% - 3rem) / 3);
  height: 22.5rem;
  border-radius: 17px;
  scroll-snap-align: start;
  background: var(--verde-escuro);

  > img {
    position: absolute;
    inset: 0;
    z-index: -2;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.4s;
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    background: linear-gradient(transparent 35%, rgba(8, 40, 25, 0.91) 100%);
  }

  &:hover > img {
    transform: scale(1.045);
  }

  > div {
    position: absolute;
    left: 1.125rem;
    right: 1.125rem;
    bottom: 1.25rem;
  }

  /* Cor explícita: o "a { color: inherit }" da página pesa mais. */
  span {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.625rem;
    color: #fff;
  }

  h3 {
    margin: 0;
    font-size: 1.125rem;
    font-weight: 600;
    line-height: 1.25;
    color: #fff;
  }

  @media (max-width: 720px) {
    flex-basis: 74%;
    height: 20rem;
  }
`;

/* ---------------------------------------------------------- visualizador */

const botaoRedondo = css`
  width: 2.5rem;
  height: 2.5rem;
  border: 1px solid rgba(255, 255, 255, 0.38);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.12);
  display: grid;
  place-items: center;
  padding: 0;
  color: #fff;
`;

export const Visualizador = styled.dialog`
  box-sizing: border-box;
  width: 100vw;
  max-width: 100vw;
  height: 100dvh;
  max-height: 100dvh;
  margin: 0;
  padding: 1.25rem 1.875rem;
  border: 0;
  background: #071a13;
  color: #fff;
  overflow: hidden;
  font-family: 'Inter', system-ui, sans-serif;

  &[open] {
    display: flex;
    flex-direction: column;
  }

  &::backdrop {
    background: rgba(5, 23, 13, 0.91);
  }

  button {
    font: inherit;
    cursor: pointer;
  }

  button:focus-visible {
    outline: 3px solid #d1a82e;
    outline-offset: 3px;
  }

  @media (max-width: 600px) {
    padding: 0.95rem 0.75rem;
  }
`;

export const VisTopo = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  padding-bottom: 0.95rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);

  > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    min-width: 0;

    span:first-child {
      overflow: hidden;
      font-size: 0.875rem;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    span:last-child {
      font-size: 0.6875rem;
      color: #b3c5ba;
    }
  }

  > div:last-child {
    display: flex;
    gap: 0.5rem;
  }

  button,
  a {
    ${botaoRedondo}
    display: grid;
    place-items: center;
    text-decoration: none;
  }
`;

export const Palco = styled.div`
  position: relative;
  flex: 1;
  min-height: 0;
  display: ${({ $zoom }) => ($zoom ? 'block' : 'flex')};
  align-items: center;
  justify-content: center;
  padding: 1.1rem 3.75rem;
  overflow: ${({ $zoom }) => ($zoom ? 'auto' : 'hidden')};

  img {
    width: ${({ $zoom }) => ($zoom ? '160%' : '100%')};
    height: ${({ $zoom }) => ($zoom ? 'auto' : '100%')};
    max-width: none;
    object-fit: contain;
    background: center / contain no-repeat;
  }

  > button {
    ${botaoRedondo}
    position: absolute;
    top: 50%;
    z-index: 2;
    transform: translateY(-50%);
  }

  > button:first-child {
    left: 0;
  }

  > button:last-of-type {
    right: 0;
  }

  @media (max-width: 600px) {
    padding: 0.75rem 0 3.4rem;

    > button {
      top: auto;
      bottom: 0.4rem;
      transform: none;
    }

    > button:first-child {
      left: calc(50% - 3.1rem);
    }

    > button:last-of-type {
      right: calc(50% - 3.1rem);
    }
  }
`;

export const Miniaturas = styled.div`
  position: relative; /* referência do offsetLeft que centraliza a miniatura atual */
  display: flex;
  flex-shrink: 0;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 0.4rem 0.125rem 0.625rem;
  scrollbar-width: thin;
  scrollbar-color: #446650 transparent;

  button {
    flex-shrink: 0;
    width: 4.6rem;
    height: 3.1rem;
    overflow: hidden;
    padding: 0;
    border: 2px solid transparent;
    border-radius: 4px;
    background: transparent;
    opacity: 0.5;
  }

  button[aria-current='true'] {
    border-color: #87cb8d;
    opacity: 1;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (max-width: 600px) {
    button {
      width: 3.75rem;
      height: 2.7rem;
    }
  }
`;

export const Ajuda = styled.p`
  flex-shrink: 0;
  margin: 0.3rem 0 0;
  text-align: center;
  font-size: 0.625rem;
  color: #93a89a;

  @media (max-width: 600px) {
    display: none;
  }
`;
